import { FC } from 'react';

interface ListContainerProps {
  children?: React.ReactNode;
  className?: string;
  emptyMessage?: string;
}

export const ListContainer: FC<ListContainerProps> = ({
  children,
  className = '',
  emptyMessage = 'No items in the list',
}) => {
  const isEmpty =
    !children || (Array.isArray(children) && children.length === 0);

  return (
    <div className={`w-full max-w-full ${className}`}>
      {isEmpty ? (
        <div className="flex items-center justify-center h-full text-gray-500">
          {emptyMessage}
        </div>
      ) : (
        <div className="flex flex-col gap-3 p-2 w-full">
          {Array.isArray(children) ? (
            children.map((child, index) => (
              <div key={index} className="w-full max-w-full overflow-hidden">
                {child}
              </div>
            ))
          ) : (
            <div className="w-full max-w-full overflow-hidden">{children}</div>
          )}
        </div>
      )}
    </div>
  );
};

ListContainer.displayName = 'ListContainer';
